"use client";

import { useId } from "react";

const TITLE_LINE_1 = "Deux offres, un seul objectif :";
const TITLE_LINE_2_PREFIX = "que votre site ";
const TITLE_LINE_2_HIGHLIGHT = "vous rapporte.";

type OffersCurvedHeroTextProps = {
  className?: string;
};

export function OffersCurvedHeroText({ className = "" }: OffersCurvedHeroTextProps) {
  const uid = useId().replace(/:/g, "");
  const titleArc1 = `offers-title-arc-1-${uid}`;
  const titleArc2 = `offers-title-arc-2-${uid}`;
  const greenGradient = `offers-green-gradient-${uid}`;

  return (
    <div className={`mx-auto w-full max-w-3xl ${className}`.trim()}>
      <h1 className="sr-only">
        {TITLE_LINE_1} {TITLE_LINE_2_PREFIX}
        {TITLE_LINE_2_HIGHLIGHT}
      </h1>

      <svg
        viewBox="0 0 800 124"
        className="h-[7.25rem] w-full overflow-visible sm:h-[7.75rem] md:h-[8.25rem]"
        aria-hidden="true"
        role="presentation"
      >
        <defs>
          <path id={titleArc1} d="M 40 52 Q 400 10 760 52" fill="none" />
          <path id={titleArc2} d="M 48 94 Q 400 58 752 94" fill="none" />
          <linearGradient id={greenGradient} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#059669" />
            <stop offset="50%" stopColor="#0d9488" />
            <stop offset="100%" stopColor="#16a34a" />
          </linearGradient>
        </defs>

        <text
          fill="#1C1C1C"
          fontFamily="var(--font-geist-sans), sans-serif"
          fontSize="34"
          fontWeight="700"
          letterSpacing="-0.04em"
        >
          <textPath href={`#${titleArc1}`} startOffset="50%" textAnchor="middle">
            {TITLE_LINE_1}
          </textPath>
        </text>

        <text
          fill="#1C1C1C"
          fontFamily="var(--font-geist-sans), sans-serif"
          fontSize="34"
          fontWeight="700"
          letterSpacing="-0.04em"
        >
          <textPath href={`#${titleArc2}`} startOffset="50%" textAnchor="middle">
            <tspan>{TITLE_LINE_2_PREFIX}</tspan>
            <tspan fill={`url(#${greenGradient})`}>{TITLE_LINE_2_HIGHLIGHT}</tspan>
          </textPath>
        </text>
      </svg>
    </div>
  );
}

export function OffersFlatHeroText({ className = "" }: OffersCurvedHeroTextProps) {
  const HERO_GRADIENT_TEXT =
    "bg-gradient-to-r from-emerald-600 via-teal-600 to-green-600 bg-clip-text text-transparent";
  const SECTION_TITLE_CLASS =
    "mx-auto max-w-4xl text-balance text-[1.65rem] font-bold leading-[1.08] tracking-[-0.04em] sm:text-[2rem] md:text-[2.35rem] md:leading-[1.05] lg:text-[2.5rem]";

  return (
    <div className={`mx-auto flex max-w-4xl flex-col items-center text-center ${className}`.trim()}>
      <h1 className={`${SECTION_TITLE_CLASS} max-w-3xl text-[#1C1C1C]`}>
        Deux offres, un seul objectif :
        <br />
        que votre site <span className={HERO_GRADIENT_TEXT}>vous rapporte.</span>
      </h1>
    </div>
  );
}
